import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

const key = ['access/types/transport_permit'];

const getAccessPermitType = async () => {
  return request.get(
    '/Access/types/transport_permit',
    {},
    'При получении типов пропусков произошла ошибка'
  );
};

const useAccessPermitType = (options) =>
  useQuery(key, getAccessPermitType, options);

export default useAccessPermitType;
